import { render, staticRenderFns } from "./roll-digit.vue?vue&type=template&id=137fe35f&"
import script from "./roll-digit.vue?vue&type=script&lang=ts&"
export * from "./roll-digit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports